import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/browser';


// VITE_VERCEL_ENV is exposed via vite.config.ts from Vercel's system VERCEL_ENV variable
const isDeployedEnvironment =
  import.meta.env.VITE_VERCEL_ENV === 'development' ||
  import.meta.env.VITE_VERCEL_ENV === 'preview' ||
  import.meta.env.VITE_VERCEL_ENV === 'production';

if (isDeployedEnvironment) {
  Sentry.init({
    dsn: 'https://fcac607edd0482f292fcd7ef4b8128e2@o4509014405545984.ingest.us.sentry.io/4509014409347072',
    integrations: [
      browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // Sample rate at 10%
    replaysOnErrorSampleRate: 1.0, // If an error occurs, sample 100%
    // Set environment based on ENV var (e.g., 'production', 'staging', etc)
    environment: import.meta.env.VITE_VERCEL_ENV || import.meta.env.__SENTRY_ENVIRONMENT__ || 'development',
    // Set release version
    release: import.meta.env.__SENTRY_RELEASE__ || 'development',
  });
}
